import React, { Component } from 'react';
import { Context } from '~/UI/Modal/Modal';

interface Props {
	children: React.ReactNode;
	contentRef?: React.RefObject<HTMLDivElement>;
}

export default class ModalBody extends Component<Props> {
	render() {
		const { children, contentRef } = this.props;

		return (
			<Context.Consumer>
				{(styles) => (
					<div className={styles.body} ref={contentRef}>
						<div className={styles.bodyIn}>{children}</div>
					</div>
				)}
			</Context.Consumer>
		);
	}
}
